module.exports = __webpack_public_path__ + "static/2-2-6-2e4440c790625c6a98e72896debad7c3.png";